import { createRequestActionTypes } from "../../../../../utils"
import { UpdateGroupAdditionalData } from "./updateGroupAdditionalData"

export const updateGroupMailboxActionTypes = createRequestActionTypes('UPDATE_GROUP_MAIL_BOX')

export type UpdateGroupMailBoxAdditionalData = UpdateGroupAdditionalData
export type UpdateGroupMailBoxResponse = string
